import { AbstractControl } from '@angular/forms';

export class AppValidators {

}



// WEBPACK FOOTER //
// ./src/app/shared/validators/app-validators.ts